import * as React from "react";
const CaretUpIcon = ({
  size = 16,
  title = "CaretUpIcon",
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: size, height: size, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "pds-icon", title, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.126 10H4.873c-.776 0-1.165-.964-.616-1.528l3.127-3.21A.86.86 0 0 1 8 5a.86.86 0 0 1 .616.262l3.127 3.21c.55.564.16 1.528-.617 1.528Z", fill: "currentColor" }));
export default CaretUpIcon;
